import { render, staticRenderFns } from "./CenteredLoader.vue?vue&type=template&id=b5f91f4a&"
import script from "./CenteredLoader.vue?vue&type=script&lang=js&"
export * from "./CenteredLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CenteredLoader.vue"
export default component.exports